module.exports = __webpack_public_path__ + "img/41.3300950f.jpg";